module.exports = {"general":{"ssm_number":"BRN (Business Registration Number)"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_shell_sg/outlet.php
// module id = n7/7
// module chunks = 113